<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <StudentGradeTable></StudentGradeTable>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";

export default {
  name: "StudentGradeView",
  components: {
    StudentGradeTable: () =>
      import("@/components/new-dashboard/StudentGradeTable"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    // ...mapGetters({
    //    user: "getUser",
    //    institution: "getInstitution",
    // }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        { text: this.$t("dashboard.dashboardView.myGrades") },
      ];
    },
  },
  methods: {},
  mounted() {},
  watch: {
    user() {},
  },
  created() {},
};
</script>

<style scoped>
</style>